import { type CurrentLocation } from "~/domains/salesPartner/types/SalesPartnerTypes";

function getCurrentPosition(options?: PositionOptions): Promise<GeolocationPosition> {
  return new Promise(function (resolve, reject) {
    navigator.geolocation.getCurrentPosition(resolve, reject, options);
  });
}

function decode(
  geocoder: google.maps.Geocoder,
  location: google.maps.LatLng,
): Promise<readonly [google.maps.GeocoderResult[], google.maps.GeocoderStatus]> {
  return new Promise((resolve) => {
    geocoder.geocode({ location: location }, (results, status) => resolve([results!, status] as const));
  });
}

export const fetchCurrentLocation = async (): Promise<CurrentLocation> => {
  const position = await getCurrentPosition({ timeout: 5000 });
  const lat = position.coords.latitude;
  const lng = position.coords.longitude;

  const geocoder = new google.maps.Geocoder();
  const [results, status] = await decode(geocoder, new google.maps.LatLng(lat, lng));

  if (status === "OK") {
    const address = results[0].address_components.find((address) => address.types.includes("country"))!;
    const data = {
      country: {
        name: address.long_name,
        isocode: address.short_name.toLowerCase(),
      },
      fullAddress: results[0].formatted_address,
      lat: lat,
      lng: lng,
    } as CurrentLocation;

    return data;
  } else {
    throw new Error(status);
  }
};
